// src/supabaseAdmin.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseServiceRoleKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;

if (!supabaseUrl || !supabaseServiceRoleKey) {
  throw new Error('Supabase URL e Service Role Key são obrigatórios para operações administrativas');
}

// Cliente admin com Service Role Key para operações privilegiadas
const supabaseAdmin = createClient(supabaseUrl, supabaseServiceRoleKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    // Chave de armazenamento diferente para evitar conflitos
    storageKey: `sb-admin-${supabaseUrl.split('//')[1].split('.')[0]}-auth-token`
  },
  global: {
    headers: {
      'x-client-info': 'admin-client' // Identificador para diferenciar nas requisições
    }
  },
  // Desativar realtime para o cliente admin para evitar conexões duplicadas
  realtime: {
    params: {
      eventsPerSecond: 0
    }
  }
});

// Função auxiliar para verificar se o cliente admin está funcionando
export const testAdminConnection = async () => {
  try {
    const { data, error } = await supabaseAdmin
      .from('profiles')
      .select('count(*)', { count: 'exact', head: true });
      
    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('❌ Erro ao testar conexão admin:', error.message);
    return { success: false, error: error.message };
  }
};

// Função para verificar se o usuário tem permissões administrativas
export const checkAdminAccess = async (userId) => {
  if (!userId) return false;
  
  try {
    const { data, error } = await supabaseAdmin
      .from('user_roles')
      .select('role')
      .eq('user_id', userId)
      .eq('role', 'admin')
      .maybeSingle();
      
    return !error && data?.role === 'admin';
  } catch (error) {
    console.error('❌ Erro ao verificar permissões administrativas:', error.message);
    return false;
  }
};

export default supabaseAdmin;